import { useEffect } from 'react';
import TableTextCell from '../../components/common/Table/TableTextCell';
import TableHeaderCell from '../../components/common/Table/TableHeaderCell';
import UserProfileCell from '../../components/common/Table/UserProfileCell';
import StageCell from '../../components/common/Table/StageCell';
import { useRequestorStore } from '../../stores/requestorStore';
import { Screens } from '../../utils/enums';
import { useAuthStore } from '../../stores/authStore';
import { UserInfo } from '../../types/auth';
import { IRequestInfo } from '../../types/requester';
import { getAllRequests } from '../../utils/api/requestApi';
import { USER } from '../../utils/constants/images';
import { getDateAndTime } from '../../utils/commonUtils';
import { STAGES, STATUSES } from '../../utils/constants';
import { getLocalActiveRole } from '../../utils/authUtils';
import { useCommonStore } from '../../stores/commonStore';

const Home = () => {
    const setActiveScreen = useRequestorStore((state) => state.setActiveScreen);
    const user: UserInfo = useAuthStore((state) => state.user);
    const setRequests = useRequestorStore((state) => state.setRequests);
    const requests: Array<IRequestInfo> = useRequestorStore((state) => state.requests);
    const activeRole = useAuthStore((state) => state.activeRole);
    const setToastMessage = useCommonStore((state) => state.setToastMessage);
    const headerData = ['request ID', 'created at', 'stage', 'action by'];

    const handleGetAllRequests = async () => {
        let roleRequested = activeRole;
        if (activeRole === '') {
            const localActiveRole = getLocalActiveRole();
            if (localActiveRole) {
                roleRequested = localActiveRole;
            }
        }
        try {
            const { data } = await getAllRequests(roleRequested);
            setRequests(data);
        } catch (e) {
            setToastMessage({ type: 'error', message: 'Something went wrong' });
            console.error(e);
        }
    };

    useEffect(() => {
        handleGetAllRequests();
        return () => setActiveScreen(Screens.HOME);
    }, []);

    return (
        <div className="container mx-auto p-8">
            <h2 className="text-xl font-semibold text-black">
                Welcome <span className="capitalize">{user?.username}</span>,
            </h2>
            <p className="text-base mt-1 text-gray-400">Here are a few updates</p>

            <div className="mx-auto mt-16">
                <div className="py-8">
                    <div className="flex flex-row mb-1 sm:mb-0 justify-between w-full">
                        <h2 className="text-xl font-semibold text-black">Previous Requests</h2>
                    </div>
                    <div className="-mx-4 sm:-mx-8 px-4 sm:px-8 py-4 overflow-x-auto">
                        <div className="inline-block min-w-full shadow-sm rounded-lg overflow-hidden">
                            <table className="min-w-full leading-normal table-auto">
                                <thead>
                                    <tr>
                                        {headerData?.map((title) => (
                                            <TableHeaderCell label={title} />
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {requests
                                        .filter((_, index) => index <= 3)
                                        .map(({ id, createdAt, stage, status, user }) => (
                                            <tr>
                                                <TableTextCell dataLabel={headerData[0]} label={id} />
                                                <TableTextCell dataLabel={headerData[1]} label={getDateAndTime(createdAt)} />
                                                <StageCell dataLabel={headerData[2]} title={STAGES[stage]} subTitle={STATUSES[status]} activeColor="#5482FF" />
                                                <UserProfileCell dataLabel={headerData[3]} imageUrl={USER} title={user?.username} subTitle={user?.email} />
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Home;
